'use client'

import Link from 'next/link'
import { trackPhoneClick } from '../../lib/analytics'
import AvailabilityBadge from '../common/AvailabilityBadge'

export default function HeroButtons({ phone }) {
    return (
        <div className="flex-responsive" style={{ display: 'flex', gap: 'var(--spacing-sm)', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: 'var(--spacing-sm)', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link href="/quote" className="btn btn-secondary" style={{ fontSize: '1.1rem', padding: '1rem 2rem', boxShadow: '0 8px 24px rgba(0,0,0,0.25)' }}>
                    Get Free Quote
                </Link>
                <Link
                    href={`tel:${phone}`}
                    className="btn btn-ghost"
                    style={{ fontSize: '1.1rem', padding: '1rem 2rem', boxShadow: '0 8px 24px rgba(0,0,0,0.2)' }}
                    onClick={() => trackPhoneClick('hero')}
                >
                    📞 Call Now
                </Link>
            </div>
            <AvailabilityBadge />
        </div>
    )
}
